<script setup>
  import LayoutHeaderAction from '@/features/layout/components/LayoutHeaderAction.vue'
  import LayoutHeaderColorModeSwitcher from '@/features/layout/components/LayoutHeaderColorModeSwitcher.vue'
  import LayoutHeaderSearch from '@/features/layout/components/LayoutHeaderSearch.vue'
  import LayoutUserProfile from '@/features/layout/components/userProfile/LayoutUserProfile.vue'
  import { useLayoutStore } from '@/features/layout/useLayoutStore.js'

  const layoutStore = useLayoutStore()
</script>

<template>
  <div class="header-left-actions">
    <LayoutHeaderAction
      v-for="actionItem of layoutStore.headerLeftActions"
      :key="actionItem.label"
      class="action-item"
      :action-item="actionItem"
    />
  </div>

  <div class="header-right-menu">
    <LayoutHeaderColorModeSwitcher />
    <LayoutHeaderSearch />

    <LayoutHeaderAction
      v-for="actionItem of layoutStore.headerRightActions"
      :key="actionItem.label"
      class="action-item"
      :action-item="actionItem"
    />

    <LayoutUserProfile />
  </div>
</template>

<style lang="scss" scoped>
  .header-right-menu {
    position: relative;
    display: flex;
    align-items: center;
    background: var(--fm-ui-header-right-menu-background-color);
    height: 100%;
    padding: 0 16px;
    border-bottom-left-radius: 30px;
    border-top-left-radius: 30px;
    gap: 10px;
  }

  .header-left-actions {
    display: flex;
    align-items: center;
    gap: 10px;
  }
</style>
